// const urlRoot = 'http://localhost:50598'
const urlRoot = '/api'
export default {
  // Endpoints
  user1QueryEndpoint: `${urlRoot}/Message/user1Query`,
  reMsguser1Endpoint: `${urlRoot}/Message/reMsguser1`,
  user2QueryEndpoint: `${urlRoot}/Message/user2Query`,
  reMsguser2Endpoint: `${urlRoot}/Message/reMsguser2`,
}
